import React, {useEffect} from "react";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {Box, Button, CircularProgress, Grid, Typography} from "@mui/material";
import {
    useCancelTerminalRelease,
    useGetTerminalRelease,
    useRecoveryTerminalRelease
} from "~/apps/packages/warehouse-closure/hooks";
import {useParams} from "react-router-dom";
import {TerminalReleaseDetail} from "~/apps/packages/warehouse-closure/components/TerminalReleaseDetail/TerminalReleaseDetail";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {canCancelTerminalRelease, canRecoveryTerminalRelease} from "~/apps/packages/warehouse-closure/utils";
import {useErrorHandler} from "~/components/ErrorHandling";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";
import {ErrorBlock} from "~/components/ErrorBlocks/ErrorBlock";
import {Search} from "@mui/icons-material";
import {ConfirmActionDialog} from "~/components/ConfirmActionDialog";


export type DetailPageProps = {}


export const DetailPage = (props: DetailPageProps) => {
    const handleError = useErrorHandler();
    const {id} = useParams<{ id: string }>();
    const {data, loading} = useGetTerminalRelease(id);
    const terminalRelease = data ? data.terminalRelease : undefined;
    const title = "Заявка на закрытие";
    const [cancel, {loading: canceling, error: cancelError}] = useCancelTerminalRelease(terminalRelease?.DocumentID);
    const [recovery, {loading: recovering, error: recoveryError}] = useRecoveryTerminalRelease(terminalRelease?.DocumentID);
    const [currentOpenDialog, setCurrentOpenDialog] = React.useState<"cancel" | "recovery" | null>(null);

    const handleCancelClick = () => {
        setCurrentOpenDialog("cancel");
    }

    const handleRecoveryClick = () => {
        setCurrentOpenDialog("recovery");
    }

    const handleConfirmAction = async () => {
        if (currentOpenDialog === "cancel") {
            cancel()
                .then(() => setCurrentOpenDialog(null))
        }
        if (currentOpenDialog === "recovery") {
            recovery()
                .then(() => setCurrentOpenDialog(null))
        }
    }

    useEffect(() => {
        if (cancelError) {
            handleError(cancelError);
        }
    }, [cancelError])

    useEffect(() => {
        if (recoveryError) {
            handleError(recoveryError);
        }
    }, [recoveryError])

    return (
        <TitleLayout title={title}>
            <ConfirmActionDialog
                open={currentOpenDialog !== null}
                dialogId={"removeCargo"}
                confirmButtonText="Подтвердить"
                onClose={() => setCurrentOpenDialog(null)}
                onConfirm={handleConfirmAction}
            >
                <Typography width="100%" align="center" variant="screenText">
                    {currentOpenDialog === 'cancel' ? 'Отозвать заявку?' : 'Восстановить заявку?'}
                </Typography>
            </ConfirmActionDialog>
            <LoadingBox loading={loading}>
                {terminalRelease && (
                    <Box paddingY={2}>
                        <TerminalReleaseDetail terminalRelease={terminalRelease}/>
                        {(canCancelTerminalRelease(terminalRelease) || canRecoveryTerminalRelease(terminalRelease)) && (
                            <Box marginTop="88px"/>
                        )}
                        <FloatingActions>
                            {canCancelTerminalRelease(terminalRelease) && (
                                <Button fullWidth color="secondary"
                                        startIcon={canceling && <CircularProgress size={16} color="inherit"/>}
                                        disabled={!canCancelTerminalRelease(terminalRelease) || canceling}
                                        onClick={handleCancelClick}
                                >
                                    Отозвать
                                </Button>
                            )}
                            {canRecoveryTerminalRelease(terminalRelease) && (
                                <Button fullWidth color="primary"
                                        startIcon={recovering && <CircularProgress size={16} color="inherit"/>}
                                        disabled={!canRecoveryTerminalRelease(terminalRelease) || recovering}
                                        onClick={handleRecoveryClick}
                                >
                                    Восстановить
                                </Button>
                            )}
                        </FloatingActions>
                    </Box>
                )}
            </LoadingBox>
        </TitleLayout>
    )
}
